export class Room {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly door: string,
    public readonly floor: string,
  ) {}
}
